import { render } from "./payment.vue?vue&type=template&id=a164ecee&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"

import "./payment.vue?vue&type=style&index=0&id=a164ecee&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a164ecee"]])

export default __exports__